/* Gallery page Make / Model filters (sections/gallery-blog.liquid) */
(() => {
  const init = (root) => {
    const makeSelect = root.querySelector('[data-gal-make]');
    const modelSelect = root.querySelector('[data-gal-model]');
    const items = Array.from(root.querySelectorAll('[data-gal-item]'));
    if (!makeSelect || !modelSelect) return;

    const allLabel = modelSelect.options[0].textContent;
    const models = Array.from(modelSelect.querySelectorAll('option[data-make]')).map((option) => ({
      value: option.value,
      label: option.textContent,
      make: option.dataset.make,
    })).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }));

    // Rebuild the Model list for the chosen make (hiding <option>s does not work in Safari)
    const buildModels = (make) => {
      const keep = modelSelect.value;
      modelSelect.innerHTML = '';
      modelSelect.add(new Option(allLabel, ''));
      models
        .filter((model) => !make || model.make === make)
        .forEach((model) => {
          const option = new Option(model.label, model.value);
          option.dataset.make = model.make;
          modelSelect.add(option);
        });
      const stillThere = Array.from(modelSelect.options).some((option) => option.value === keep);
      modelSelect.value = stillThere ? keep : '';
    };

    const apply = () => {
      const make = makeSelect.value;
      const model = modelSelect.value;
      items.forEach((item) => {
        const itemMakes = item.dataset.make.split(' ');
        const itemModels = item.dataset.model.split(' ');
        const show = (!make || itemMakes.includes(make)) && (!model || itemModels.includes(model));
        item.hidden = !show;
      });
    };

    makeSelect.addEventListener('change', () => {
      modelSelect.value = '';
      buildModels(makeSelect.value);
      apply();
    });

    modelSelect.addEventListener('change', apply);

    // A link can preselect the filters, e.g. /blogs/gallery?make=toyota&model=toyota-gr86
    // (the product page's "From the Gallery" > View all)
    const params = new URLSearchParams(window.location.search);
    const urlMake = params.get('make');
    const urlModel = params.get('model');
    if (urlMake && Array.from(makeSelect.options).some((option) => option.value === urlMake)) {
      makeSelect.value = urlMake;
    }

    // Browsers can restore select values on back navigation, so sync on load
    buildModels(makeSelect.value);
    if (urlModel && Array.from(modelSelect.options).some((option) => option.value === urlModel)) {
      modelSelect.value = urlModel;
    }
    apply();
  };

  document.querySelectorAll('[data-gal]').forEach(init);
})();